export default "__VITE_ASSET__Dw4uwKuA__"